// Picks black or white for something drawn on top of `background` (a #rgb/#rrggbb hex), so icons
// stay visible when the theme is inverted for the PDF export. Anything unparseable falls back to
// white — the answer for the app's default black background.
export const contrastColor = (background: string): '#000000' | '#ffffff' => {
  let hex = background.replace('#', '');
  if (hex.length === 3) {
    hex = hex.replace(/./g, (c) => c + c);
  }
  if (!/^[0-9a-f]{6}$/i.test(hex)) {
    return '#ffffff';
  }
  const [r, g, b] = [0, 2, 4].map((i) => Number.parseInt(hex.slice(i, i + 2), 16));
  const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
  return luminance > 0.5 ? '#000000' : '#ffffff';
};
